/*
 * Part of the RubinRed CMS.
 * @author    Mattia Clementi <clementi@workup.it>
 * @license   Proprietary
 * @copyright 2015-2017, Workup Srl
 * @link      http://rubinred.it
 */

export default class TagManager {
  constructor() {
    this.cookie_name = '_ga_rubinred_id';
    //TODO: where does ga come from?
    this.getCookieGoogleAnalytics();
  }

  getCookieGoogleAnalytics() {
    if (typeof ga !== 'undefined') {
      ga(() => {
        let tracker = ga.getAll()[0];
        let clientId = tracker.get('clientId');
        document.cookie = this.cookie_name + "=" + clientId + ";secure;HttpOnly;";
      });
    }
  }

  pushJson(json) {
    window.dataLayer.push(json);
  }

  pushEventJson(json) {
    let jsonEvent = {
      'event' : json,
    };
    window.dataLayer.push(jsonEvent);
  }

  push(key, value) {
    if (key === 'event') {
      return this.pushEvent(value);
    }
    this.data = {};
    this.data[key] = value;
    window.dataLayer.push(this.data);
  }

  pushEvent(value) {
    this.data = {};
    this.data.event = value;
    window.dataLayer.push(this.data);
  }
}

window.App.Blueprints.TagManager = TagManager;


// WEBPACK FOOTER //
// ./public/themes/frontend/uikit3/extensions/rubinred/tag-manager/assets/js/Tags.js